import * as i0 from '@angular/core';
import { InjectionToken, NgModule, Optional, SkipSelf } from '@angular/core';
import { createServiceApi, serviceTypes, combineEffectsWithProviders } from '@essent/common';
import * as i1 from '@ngrx/effects';
import { EffectsModule } from '@ngrx/effects';

const apiVersion = '2';
const getInstallationAddressesApi = createServiceApi('[InstallationAddressState] Get installation addresses', 'get', serviceTypes(), {
    getUrl: `/contracting/contracts/addresses/v${apiVersion}`,
    version: apiVersion,
    getParams: payload => payload
});

/**
 * @ignore
 */
const API = new InjectionToken('api-installation-addresses');

const { EFFECTS, PROVIDERS } = combineEffectsWithProviders(getInstallationAddressesApi);
/**
 * ModuleGetInstallationAddressesService
 *
 * ### Example usage
 *
 * #### Normal
 * ```typescript
 * providers: [
 *     InstallationAddressCoreModule,
 *     ...
 * ]
 * ```
 *
 * #### Custom API
 *
 * ```typescript
 * providers: [
 *     InstallationAddressCoreModule.forRoot({
 *         api: 'https://my-api.com'
 *     }),
 *     ...
 * ]
 * ```
 */
class InstallationAddressCoreModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('InstallationAddressCoreModule is imported more than once.');
        }
    }
    static forRoot(config) {
        return {
            ngModule: InstallationAddressCoreModule,
            providers: [
                {
                    provide: API,
                    useValue: config ? config.api : undefined
                }
            ]
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: InstallationAddressCoreModule, deps: [{ token: InstallationAddressCoreModule, optional: true, skipSelf: true }], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.7", ngImport: i0, type: InstallationAddressCoreModule, imports: [i1.EffectsFeatureModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: InstallationAddressCoreModule, providers: PROVIDERS, imports: [EffectsModule.forFeature(EFFECTS)] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: InstallationAddressCoreModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [EffectsModule.forFeature(EFFECTS)],
                    providers: PROVIDERS
                }]
        }], ctorParameters: () => [{ type: InstallationAddressCoreModule, decorators: [{
                    type: Optional
                }, {
                    type: SkipSelf
                }] }] });

const { getInstallationAddressesActions, getInstallationAddresses, getInstallationAddressesSuccess, getInstallationAddressesError, getInstallationAddressesClear } = getInstallationAddressesApi;

/**
 * Generated bundle index. Do not edit.
 */

export { API, InstallationAddressCoreModule, getInstallationAddresses, getInstallationAddressesActions, getInstallationAddressesClear, getInstallationAddressesError, getInstallationAddressesSuccess };
